import { UserInterface } from '@/types'

export function getCurrentUser(): UserInterface | null {
    const userStr = localStorage.getItem('user')
    if (!userStr) return null
    
    try {
        return JSON.parse(userStr) as UserInterface
    } catch {
        return null
    }
}

export function hasRole(role: string): boolean {
    const user = getCurrentUser()
    if (!user) return false
    
    // If user doesn't have roles property, check if it's stored differently
    const userRoles = (user as any).roles || []
    return userRoles.includes(role)
}

export function isAdmin(): boolean {
    return hasRole('ROLE_ADMIN')
}

export function isContributor(): boolean {
    return hasRole('ROLE_CONTRIBUTOR') || 
           hasRole('ROLE_CONTRIBUTOR_TERROIR') || 
           hasRole('ROLE_CONTRIBUTOR_COMMUNE') || 
           hasRole('ROLE_CONTRIBUTOR_PRODUCT')
}